export default {
    props: {
        allowExportData: {
            type: Boolean,
            default: false
        },
    }
};